<template>
  <div id="face-images">
    <center><h2>Face Images</h2></center>
    <div v-if="loading">Loading...</div>
    <div class="row">
      <div class="header-column">&nbsp;</div>
      <div class="header-column">Orig</div>
      <div class="header-column">Exp +0.05</div>
      <div class="header-column">Exp +0.10</div>
      <div class="header-column">Exp +0.15</div>
      <div class="header-column">Exp +0.20</div>
      <div class="header-column">Exp +0.25</div>
    </div>
    <div v-for="face of faces" :key="face.runtime_face_uuid" class="row">
      <div class="img">
        <img :src="'http://node-runner.p.owal.io:9612/faceimage/' + face.runtime_face_uuid" height='160dp' />
      </div>
      <div class="img">
        <img :src="'https://yakov.owal.io/api/v6/faces/images/' + face.runtime_face_uuid + '?shape=1&expanded=0'" height='160dp' />
      </div>
      <div class="img">
        <img :src="'https://yakov.owal.io/api/v6/faces/images/' + face.runtime_face_uuid + '?shape=1&expanded=1&expand_ratio=0.05'" height='160dp' />
      </div>
            <div class="img">
        <img :src="'https://yakov.owal.io/api/v6/faces/images/' + face.runtime_face_uuid + '?shape=1&expanded=1&expand_ratio=0.10'" height='160dp' />
      </div>
            <div class="img">
        <img :src="'https://yakov.owal.io/api/v6/faces/images/' + face.runtime_face_uuid + '?shape=1&expanded=1&expand_ratio=0.15'" height='160dp' />
      </div>
            <div class="img">
        <img :src="'https://yakov.owal.io/api/v6/faces/images/' + face.runtime_face_uuid + '?shape=1&expanded=1&expand_ratio=0.20'" height='160dp' />
      </div>
            <div class="img">
        <img :src="'https://yakov.owal.io/api/v6/faces/images/' + face.runtime_face_uuid + '?shape=1&expanded=1&expand_ratio=0.25'" height='160dp' />
      </div>
    </div>
  </div>
</template>

<script>

import {mapGetters} from 'vuex';
import {facesrecent} from '../api/faces';

export default {
  name: 'face-images',
  data: function() {
    return {
      faces: [],
      loading: false,
    }
  },
  computed: mapGetters(['frontendFaces', 'isLoggedIn']),
  created() {
    this.updateResults()
  },
  methods: {
    updateResults() {
      this.loading = true
      facesrecent().then(res => res.data).then(data => {
        this.loading = false;
        if (!data.ok) {
          return console.error(data.err);
        }
        this.faces = data.faces;
      })
    }
  }
}
</script>

<style scoped>

.row {
  display: flex;
  flex-direction: row;
  justify-content: center;
}

.img {
  flex: 1;
}

.header-column {
  flex: 1;
}

</style>



// WEBPACK FOOTER //
// FaceImages.vue?f2673a6a